/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignPipelineConfigShow } from '../../axios/campaignPipelineConfigShow'
import type {
	CampaignPipelineConfigShowError,
	CampaignPipelineConfigShowPathParams,
	CampaignPipelineConfigShowResponse,
} from '../../types/CampaignPipelineConfigShow'

export const campaignPipelineConfigShowQueryKey = (campaign: CampaignPipelineConfigShowPathParams['campaign']) =>
	[{ url: '/campaigns/:campaign/pipeline-config', params: { campaign } }] as const

export type CampaignPipelineConfigShowQueryKey = ReturnType<typeof campaignPipelineConfigShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::show */
export function campaignPipelineConfigShowQueryOptions(
	campaign: CampaignPipelineConfigShowPathParams['campaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CampaignPipelineConfigShowResponse,
		AxiosError<CampaignPipelineConfigShowError>,
		CampaignPipelineConfigShowResponse,
		CampaignPipelineConfigShowQueryKey
	>({
		queryKey: campaignPipelineConfigShowQueryKey(campaign),
		queryFn: ({ signal }) => campaignPipelineConfigShow(campaign, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::show */
export function useCampaignPipelineConfigShow<TSelectData = CampaignPipelineConfigShowResponse>(
	campaign: CampaignPipelineConfigShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CampaignPipelineConfigShowResponse,
					AxiosError<CampaignPipelineConfigShowError>,
					TSelectData,
					CampaignPipelineConfigShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CampaignPipelineConfigShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...campaignPipelineConfigShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::show */
export function useCampaignPipelineConfigShowSuspense<TSelectData = CampaignPipelineConfigShowResponse>(
	campaign: CampaignPipelineConfigShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CampaignPipelineConfigShowResponse,
					AxiosError<CampaignPipelineConfigShowError>,
					TSelectData,
					CampaignPipelineConfigShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CampaignPipelineConfigShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...campaignPipelineConfigShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
